import {
  FaFacebookF,
  FaGithub,
  FaLinkedinIn,
  FaPhone,
  FaWhatsapp,
} from "react-icons/fa";
import "./Hero.css";
import Typewriter from "typewriter-effect";
const Hero = () => {
  return (
    <div id="hero" className="container">
      <div className="row w-100 mx-auto">
        <div className="col-sm-8 order-2 order-sm-1 text-sm-start text-center">
          <div className="fw-bold" data-aos="fade-up">
            <h4 className="fw-bold my-2 pt-5">Hello! I&apos; m</h4>
            <h1 className="fw-bold my-2 ">Md Shoyeb</h1>
            <h4 className="my-2 fw-bold d-flex">
              <span> And My Expertise in&nbsp; </span>{" "}
              <span className="text-green">
                <Typewriter
                  options={{
                    strings: [
                      "Software Development",
                      "Full Stack Development",
                      "Application Development",
                      "Backend Development",
                      "Frontend Development",
                    ],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </span>
            </h4>
          </div>
          <p className="my-4" data-aos="fade-up">
            I can provide high-quality products and ensure 100% dedication to
            your business needs, leveraging my skills. For projects or full-time
            opportunities, please reach out through my contact details.
          </p>
          <div
            className="d-flex justify-content-center justify-content-sm-start social-icons gap-4 mt-5"
            data-aos="fade-right"
          >
            <a
              href="https://www.linkedin.com/in/md-shoyeb-49645020a/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green"
            >
              <FaLinkedinIn size={40} />
            </a>
            <a
              href="http://wa.me/919871904481"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green"
            >
              <FaWhatsapp size={40} />
            </a>

            <a
              href="http://github.com/shoyebmd424"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green"
            >
              <FaGithub size={40} />
            </a>
            <a
              href="http://facebook.com/shoyeb"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green"
            >
              <FaFacebookF size={40} />
            </a>
            {/* <a
              href="http://instagram.com/shoyebmd424"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green"
            >
              <FaInstagram size={40} />
            </a> */}
            <a
              href="tel:+919871904481"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green"
            >
              <FaPhone size={40} />
            </a>
          </div>
          <div data-aos="fade-top">
            <div className="mt-5">
              <a
                href="https://drive.google.com/file/d/1gVSjZPjZWShFa9cVLj7pOaFJ8tWxGD9S/view?usp=drive_link"
                target="_blank"
                rel="noopener noreferrer"
                className="px-5 py-2 hero-btn text-decoration-none"
              >
                Download CV
              </a>
            </div>
          </div>
        </div>
        <div className="col-md-4 d-flex my-5 my-sm-auto  mx-auto order-1 order-sm-2">
          <div className="position-relative hero-img">
            <img src="/shoyeb/images/hero2.png" alt="hero" className="m-auto" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
